module.exports = __webpack_public_path__ + "img/grevin_montreal.4498ec33.webp";